// A theme's high-definition backgrounds: where each is served from, and which
// one a board shows. B cycles through them, like wallpapers.

import type { ThemeBackground } from "../../shared/types";
import { LIB_KEY } from "../../shared/library";

/** Where a background is served from: the board's own library ships with the app, the rest the board keeps. */
export const backgroundUrl = (key: string) => (LIB_KEY.test(key) ? `/library/${key.slice(4)}` : `/api/img/${key}`);

/** A small copy for the picker, where there is one. */
export const backgroundThumb = (key: string) => (LIB_KEY.test(key) ? `/library/thumbs/${key.slice(4)}` : backgroundUrl(key));

/** The background a board shows of its theme's pictures: the one it picked, or the first. */
export function pickBackground(pics: ThemeBackground[] | undefined, pick: number | null | undefined): ThemeBackground | null {
  if (!pics?.length) return null;
  const n = pics.length;
  return pics[(((pick ?? 0) % n) + n) % n];
}
